/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ColorEnum {
    GREEN = 'green',
    YELLOW = 'yellow',
    RED = 'red',
    GRAY = 'gray',
}